export default __webpack_public_path__ + "static/media/BackgroundImageDark.731ec7ba.jpg";